import * as React from 'react';
import { IRegion, IRegionsByID } from '../../../../types/regions';
import { Clickable } from '../../../../components/Clickable';
import { Container } from '../../../../components/Container';
import { Text } from '../../../../components/Text';
import { SIZE_12, SIZE_20, SIZE_24, SIZE_300, SIZE_WIDE } from '../../../../constants/sizes';
import { TCityModalStep } from './CityModal';
import { RadioButton } from '../../../../components/RadioButton';
import { ISearchCatalogItemSchema } from '@cian/api-models/monolith-python/cian-api/site/v1/search-regions-cities';
import { Icon } from '../../../../components/Icon';
import {
  isMoscowAndMoscowArea, isMoscowOrMoscowArea, isSBPOrLo,
  isSPBAndLo,
  LO_ID,
  MOSCOW_AND_MOSCOW_AREA_ID,
  MOSCOW_AREA_ID,
  MOSCOW_ID, SPB_AND_LO_ID, SPB_ID,
} from '../../../../utils/geo';

export interface ICityModalContentProps {
  onClick(region: IRegion): void;
  regionColumns: IRegion[][][];
  step: TCityModalStep;
  mainRegions: (IRegion | ISearchCatalogItemSchema)[];
  currentRegion: IRegion | ISearchCatalogItemSchema;
  regionsByID: IRegionsByID;
}
export interface ICityModalContentState {
}

export class CityModalContent extends React.Component<ICityModalContentProps, ICityModalContentState> {
  public render() {
    const { regionColumns, step, currentRegion } = this.props;
    let mainRegions = this.getMainRegions();

    return (
      <>
        <Container>
          {mainRegions.map((region: IRegion) =>
            <Container
              key={region.id}
              padding={`0 0 ${SIZE_20}`}
            >
              {step === 2
                ? <RadioButton
                  onClick={this.handleClick(region)}
                  name="city"
                  checked={region.id === currentRegion.id}
                  value={region.id}
                >
                  <Text colorHovered="red">
                    {region.fullName}
                  </Text>
                </RadioButton>
                : <Clickable onClick={this.handleClick(region)}>
                  <Text colorHovered="red">
                    {region.fullName}
                  </Text>
                </Clickable>
              }
            </Container>,
          )}
        </Container>
        <Container
          display="flex"
        >
          {!regionColumns[0].length && !mainRegions.length
            ? <Container
              display="flex"
              justifyContent="center"
              alignItems="center"
              width={SIZE_WIDE}
              height={SIZE_300}
            >
              <Icon type="loader" color="blue" size={40}/>
            </Container>
            : regionColumns.map((column: IRegion[][], index: number) =>
              <Container
                key={`column-${index}`}
                width={SIZE_WIDE}
              >
                {column.map((regionArray: IRegion[], j: number) =>
                  <Container
                    key={j}
                  >
                    <Text
                      fontWeight="bold"
                      fontSize={18}
                      lineHeight={28}
                    >
                      {regionArray[0].displayName[0]}
                    </Text>
                    <Container margin={`${SIZE_12} 0 ${SIZE_24}`}>
                      {regionArray.map((region: IRegion) =>
                        <Container
                          key={region.id}
                          padding={`0 0 ${SIZE_20}`}
                        >
                          {step === 2
                            ? <RadioButton
                              onClick={this.handleClick(region)}
                              checked={region.id === currentRegion.id}
                              name="city"
                              value={region.id}
                            >
                              <Text colorHovered="red">
                                {region.displayName}
                              </Text>
                            </RadioButton>
                            : <Clickable onClick={this.handleClick(region)}>
                              <Text colorHovered="red">
                                {region.displayName}
                              </Text>
                            </Clickable>
                          }
                        </Container>,
                      )}
                    </Container>
                  </Container>,
                )}
              </Container>,
            )}
        </Container>
      </>
    );
  }

  private getMainRegions = () => {
    let {
      currentRegion,
      regionsByID,
      step,
      mainRegions,
    } = this.props;
    const region = currentRegion.parentId ? regionsByID[currentRegion.parentId] : currentRegion;

    if (step === 2 && (isMoscowAndMoscowArea(region) || isMoscowOrMoscowArea(region))) {
      return [
        regionsByID[MOSCOW_AND_MOSCOW_AREA_ID], regionsByID[MOSCOW_AREA_ID], regionsByID[MOSCOW_ID],
      ];
    } else if (step === 2 && (isSPBAndLo(region) || isSBPOrLo(region))) {
      return [
        regionsByID[SPB_AND_LO_ID], regionsByID[LO_ID], regionsByID[SPB_ID],
      ];
    }

    return mainRegions;
  }

  private handleClick = (region: IRegion) => () => {
    this.props.onClick(region);
  }
}
